import React, { createRef, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

const ThumbnailComponent = ({ url, file, style }) => (
  <img
    style={{
      width: "100%",
      height: "100%",
      minHeight: 150,
      ...style,
    }}
    src={url ? url : URL.createObjectURL(file)}
  />
);

const MediaUpload = ({
  children,
  onUploadComplete,
  acceptTypes = "*/*",
  style,
  forwardRef,
  preview = null,
  ...props
}) => {
  const [media, setMedia] = useState({ thumbnail: null, file: null });

  const onUploadRequest = () => {
    ref.current.click();
  };

  const onRemoveRequest = () => {
    setMedia({ thumbnail: null, file: null });
    onUploadComplete(null);
  };

  const onFileSelected = (e) => {
    if (e.target.files.length) {
      onUploadComplete(Array.from(e.target.files));

      for (var file of e.target.files) {
        setMedia((m) => ({
          ...m,
          thumbnail: <ThumbnailComponent file={file} style={style} />,
          file,
        }));
      }
    }
  };

  let ref = (forwardRef && forwardRef(createRef())) || createRef();

  useEffect(() => {
    if (preview) {
      setMedia((m) => ({
        ...m,
        thumbnail: <ThumbnailComponent url={preview} style={style} />,
      }));
    }
  }, [preview]);

  return (
    <>
      <input
        onChange={onFileSelected}
        ref={ref}
        multiple
        accept={acceptTypes}
        type="file"
        style={{ display: "none" }}
      />
      {children({
        onUploadComplete,
        onUploadRequest,
        onRemoveRequest,
        media,
      })}
    </>
  );
};

MediaUpload.propTypes = {
  acceptTypes: PropTypes.string.isRequired,
  onUploadComplete: PropTypes.func.isRequired,
};

export default React.memo(MediaUpload);
